"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineBaseUrl = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const determineBaseUrl = () => {
    const isHybrid = (0, web_ui_framework_1.isWebViewPlatform)();
    let baseUrl = isHybrid ? window.TEALIUM_HYBRID_BASE_URL : window.TEALIUM_BASE_URL;
    if (!baseUrl) {
        const variant = window.COUNTRY;
        if (isHybrid) {
            const hybridUrls = {
                us: 'https://tags.openbank.digitalsanbank-hyb/prod/',
                ar: 'https://teal.openbank.com.ar/hyb-mb-ar/prod/',
                mx: 'https://teal.openbank.mx/hyb-mb-mx/prod/',
            };
            baseUrl = hybridUrls[variant] || `https://teal.openbank.${variant}/hyb-mb-${variant}/prod/`;
        }
        else {
            const webUrls = {
                us: 'https://tags.openbank.digitalsanbank-web/prod/',
                ar: 'https://teal.openbank.com.ar/web-mb-ar/prod/',
                mx: 'https://teal.openbank.mx/web-mb-mx/prod/',
            };
            baseUrl = webUrls[variant] || `https://teal.openbank.${variant}/web-ok-${variant}/prod/`;
        }
    }
    return baseUrl;
};
exports.determineBaseUrl = determineBaseUrl;
//# sourceMappingURL=determineBaseUrl.js.map